import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchAppIdeas, fetchAppIdeaFavorites, toggleAppIdeaFavorite, deleteAppIdea } from './database-app-ideas';
import { AppIdea } from './database-app-ideas';

export const useFetchAppIdeas = () => {
  return useQuery<AppIdea[]>({
    queryKey: ['app-ideas'],
    queryFn: fetchAppIdeas,
  });
};

export const useFetchAppIdeaFavorites = () => {
  return useQuery({
    queryKey: ['app-idea-favorites'],
    queryFn: fetchAppIdeaFavorites,
  });
};

export const useToggleAppIdeaFavorite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ appIdeaId, isFavorited }: { appIdeaId: string, isFavorited: boolean }) => 
      toggleAppIdeaFavorite(appIdeaId, isFavorited),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['app-ideas'] });
      queryClient.invalidateQueries({ queryKey: ['app-idea-favorites'] });
    },
  });
};

export const useDeleteAppIdea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (appIdeaId: string) => deleteAppIdea(appIdeaId),
    onSuccess: () => {
      // Invalidate all app idea related queries to ensure immediate UI updates
      queryClient.invalidateQueries({ queryKey: ['app-ideas'] });
      queryClient.invalidateQueries({ queryKey: ['app-idea-favorites'] });
    },
    onError: (error) => {
      console.error('Failed to delete app idea:', error);
    },
  });
};
